import { LOCALES, LOCALE_LABEL, useTranslation, type Locale } from '../i18n';

// 네이티브 <option>은 CSS padding-left를 무시하는 브라우저가 많고,
// 일반 공백은 HTML 파서가 collapse한다. U+00A0 (non-breaking space)는
// trim/collapse되지 않아 모든 브라우저에서 동일한 들여쓰기를 보장한다.
const NBSP = ' ';
const INDENT = NBSP.repeat(2);

export function LocaleSwitcher() {
  const { locale, setLocale, t } = useTranslation();
  return (
    <label className="locale-select-wrap" aria-label={t('nav.localeSelect')}>
      <svg
        className="locale-select-icon"
        viewBox="0 0 24 24"
        width="14"
        height="14"
        aria-hidden="true"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18" />
        <path d="M12 3a13.5 13.5 0 0 1 0 18" />
        <path d="M12 3a13.5 13.5 0 0 0 0 18" />
      </svg>
      <select
        className="locale-select"
        value={locale}
        onChange={(e) => setLocale(e.target.value as Locale)}
      >
        {LOCALES.map((l) => (
          <option key={l} value={l}>
            {INDENT + LOCALE_LABEL[l] + INDENT}
          </option>
        ))}
      </select>
    </label>
  );
}
